<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    import { writable } from 'svelte/store';
    import {
        subscribeToServerEvents,
        type Unsubscriber
    } from '$lib/serverEvents';
    import type {ImportStatusMessage} from "$lib/models/ImportStatusMessage";
    import { ImportMessageType } from '$lib/models/ImportMessageType';

    const messages = writable<ImportStatusMessage[]>([]);
    const { diffId } = $props<{ diffId?: string }>();

    let unsubscribeToServerEvents: Unsubscriber | undefined;

    onMount(() => {
        if (!diffId) return;
        unsubscribeToServerEvents = subscribeToServerEvents(
            (importStatusMessage) => {
                messages.update((list) => [importStatusMessage, ...list]);

                if (importStatusMessage.type === ImportMessageType.FAILED || importStatusMessage.type === ImportMessageType.COMPLETED) {
                    unsubscribeToServerEvents?.();
                }
            },
            diffId
        );
    });

    onDestroy(() => {
        unsubscribeToServerEvents?.();
    });
</script>

<div class="col-span-2">
  <h3>Import Status</h3>
  {#if $messages.length === 0}
    <div class="italic">No status messages yet.</div>
  {:else}
    {#each $messages as msg (msg.diffId + ':' + msg.type + ':' + msg.message + ':' + msg.timestamp)}
      <div class={'grid grid-cols-6 ' + msg.type.toLowerCase()}>
        <div class="col-span-1 gap-1">{msg.timestamp}</div>
        <div class="col-span-1 text-center">{msg.type}</div>
        <div class="col-span-4">{msg.message}</div>
      </div>
    {/each}
  {/if}
</div>